import { Attachment } from '../../../../../entities/Subentities';
import OptionsPicker, { Option } from '../../../inputs/OptionsPicker';
import { orderByIds } from '../../../../utils/common';

type ImageOption = Option & { key: string };

type Props = {
    readOnly?: boolean
    selectedIds: string[];
    images: Attachment[];
    onChange: (selectedIds: string[])   => void;
};

export const ImagePicker = (props: Props) => {
    const items = props.images.map(_ => ({ key: _.id, text: _.attributes.Name }));
    const selectedItems = orderByIds(items, props.selectedIds, item => item.key);

    const onResolveSuggestions = (filter: string, selectedOptions?: ImageOption[]) => {
        let array = Promise.resolve(items);

        const normalizedFilter = filter.trim().toLowerCase();
        if (filter) {
            array = array.then(_ => _.filter(__ => __.text.toLowerCase().startsWith(normalizedFilter)));
        }

        if (selectedOptions?.length) {
            const isSelected = (option: ImageOption) => selectedOptions.some(_ => _.text === option.text);
            const filterSelectedItems = (options: ImageOption[]) => options.filter(_ => !isSelected(_));
            array = array.then(_ => filterSelectedItems(_));
        }

        return array;
    };

    const onChange = (options: ImageOption[]) => {
        props.onChange(options.map(_ => _.key));
    };

    return (
        <OptionsPicker
            readOnly={props.readOnly}
            adjustOptionsListWidth={false}
            selectedItems={selectedItems}
            onChange={onChange}
            onResolveSuggestions={onResolveSuggestions}
            pickerSuggestionsProps={{ noResultsFoundText: "No images found", loadingText: 'Loading' }}
        />
    );
};